import { SEOHead } from '../components/common/SEOHead';
import { Breadcrumbs } from '../components/common/Breadcrumbs';
import { Link } from 'react-router-dom';

export const CookiesPage = () => {
  return (
    <>
      <SEOHead
        title="Política de Cookies | REALimenta"
        description="Política de cookies del sitio web REALimenta - Información sobre las cookies que utilizamos."
        canonical="/politica-cookies"
        noIndex={true}
      />

      <section className="pt-12 pb-20 md:pb-28">
        <div className="section-container">
          <Breadcrumbs items={[{ label: 'Política de Cookies' }]} />

          <article className="max-w-3xl" data-testid="cookies-content">
            <h1 className="font-manrope text-4xl sm:text-5xl font-extrabold text-text-primary tracking-tighter mb-8">
              Política de Cookies
            </h1>

            <div className="prose prose-lg text-text-secondary space-y-8">

              {/* Acceso */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  ACCESO A ESTE SITIO WEB
                </h2>
                <p>
                  El acceso a este sitio web puede implicar la utilización de cookies. Las cookies son pequeñas cantidades de información que se almacenan en el navegador utilizado por cada usuario —en los distintos dispositivos que pueda utilizar para navegar— para que el servidor recuerde cierta información que posteriormente y únicamente el servidor que la implementó leerá. Las cookies facilitan la navegación, la hacen más amigable, y no dañan el dispositivo de navegación.
                </p>
                <p>
                  Las cookies son procedimientos automáticos de recogida de información relativa a las preferencias determinadas por el usuario durante su visita al sitio web con el fin de reconocerlo como usuario, y personalizar su experiencia y el uso del sitio web, y pueden también, por ejemplo, ayudar a identificar y resolver errores.
                </p>
                <p>
                  La información recabada a través de las cookies puede incluir la fecha y hora de visitas al sitio web, las páginas visionadas, el tiempo que ha estado en el sitio web y los sitios visitados justo antes y después del mismo. Sin embargo, ninguna cookie permite que esta misma pueda contactarse con el número de teléfono del usuario o con cualquier otro medio de contacto personal. Ninguna cookie puede extraer información del disco duro del usuario o robar información personal. La única manera de que la información privada del usuario forme parte del archivo Cookie es que el usuario dé personalmente esa información al servidor.
                </p>
                <p>
                  Las cookies que permiten identificar a una persona se consideran datos personales. Por tanto, a las mismas les será de aplicación la Política de Privacidad anteriormente descrita. En este sentido, para la utilización de las mismas será necesario el consentimiento del usuario. Este consentimiento será comunicado, en base a una elección auténtica, ofrecido mediante una decisión afirmativa y positiva, antes del tratamiento inicial, removible y documentado.
                </p>
              </section>

              {/* Cookies propias */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  COOKIES PROPIAS
                </h2>
                <p>
                  Son aquellas cookies que son enviadas al ordenador o dispositivo del usuario y gestionadas exclusivamente por el Titular para el mejor funcionamiento del sitio web. La información que se recaba se emplea para mejorar la calidad del sitio web y su contenido y su experiencia como usuario. Estas cookies permiten reconocer al usuario como visitante recurrente del sitio web y adaptar el contenido para ofrecerle contenidos que se ajusten a sus preferencias.
                </p>
              </section>

              {/* Cookies de terceros */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  COOKIES DE TERCEROS
                </h2>
                <p>
                  Son cookies utilizadas y gestionadas por entidades externas que proporcionan al Titular servicios solicitados por este mismo para mejorar el sitio web y la experiencia del usuario al navegar en el sitio web.
                </p>
                <p>
                  Los principales objetivos para los que se utilizan cookies de terceros son la obtención de estadísticas de accesos y analizar la información de la navegación, es decir, cómo interactúa el usuario con el sitio web.
                </p>
                <p>
                  La información que se obtiene se refiere, por ejemplo, al número de páginas visitadas, el idioma, el lugar a la que la dirección IP desde el que accede el usuario, el número de usuarios que acceden, la frecuencia y reincidencia de las visitas, el tiempo de visita, el navegador que usan, el operador o tipo de dispositivo desde el que se realiza la visita. Esta información se utiliza para mejorar el sitio web, y detectar nuevas necesidades para ofrecer a los usuarios un contenido y/o servicio de óptima calidad. En todo caso, la información se recopila de forma anónima y se elaboran informes de tendencias del sitio web sin identificar a usuarios individuales.
                </p>
                <p>
                  Puede obtener más información sobre las cookies, la información sobre la privacidad, o consultar la descripción del tipo de cookies que se utiliza, sus principales características, periodo de expiración, etc. en el siguiente(s) enlace(s):
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>PostHog: posthog.com</li>
                </ul>
                <p>
                  La(s) entidad(es) encargada(s) del suministro de cookies podrá(n) ceder esta información a terceros, siempre y cuando lo exija la ley o sea un tercero el que procese esta información para dichas entidades.
                </p>
              </section>

              {/* Cookies de redes sociales */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  COOKIES DE REDES SOCIALES
                </h2>
                <p>
                  El Titular incorpora plugins de redes sociales, que permiten acceder a las mismas a partir del sitio web. Por esta razón, las cookies de redes sociales pueden almacenarse en el navegador del usuario. Los titulares de dichas redes sociales disponen de sus propias políticas de protección de datos y de cookies, siendo ellos mismos, en cada caso, responsables de sus propios ficheros y de sus propias prácticas de privacidad. El usuario debe referirse a las mismas para informarse acerca de dichas cookies y, en su caso, del tratamiento de sus datos personales. Únicamente a título informativo se indican a continuación los enlaces en los que se pueden consultar dichas políticas de privacidad y/o de cookies:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Facebook: facebook.com/policies/cookies/</li>
                  <li>Instagram: instagram.com/legal/cookies/</li>
                </ul>
              </section>

              {/* Deshabilitar, rechazar y eliminar */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  DESHABILITAR, RECHAZAR Y ELIMINAR COOKIES
                </h2>
                <p>
                  El usuario puede deshabilitar, rechazar y eliminar las cookies —total o parcialmente— instaladas en su dispositivo mediante la configuración de su navegador (entre los que se encuentran, por ejemplo, Chrome, Firefox, Safari, Explorer). En este sentido, los procedimientos para rechazar y eliminar las cookies pueden diferir de un navegador de Internet a otro. En consecuencia, el usuario debe acudir a las instrucciones facilitadas por el propio navegador de Internet que esté utilizando. En el supuesto de que rechace el uso de cookies —total o parcialmente— podrá seguir usando el sitio web, si bien podrá tener limitada la utilización de algunas de las prestaciones del mismo.
                </p>
                <p>
                  Puede consultar cómo gestionar las cookies en los navegadores más populares:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <strong>Google Chrome:</strong> Configuración → Privacidad y seguridad → Cookies y otros datos de sitios
                  </li>
                  <li>
                    <strong>Mozilla Firefox:</strong> Opciones → Privacidad y seguridad → Cookies y datos del sitio
                  </li>
                  <li>
                    <strong>Safari:</strong> Preferencias → Privacidad → Gestionar datos de sitios web
                  </li>
                  <li>
                    <strong>Microsoft Edge:</strong> Configuración → Privacidad, búsqueda y servicios → Cookies y permisos del sitio
                  </li>
                </ul>
              </section>

              {/* Tabla de cookies */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  COOKIES UTILIZADAS EN ESTE SITIO WEB
                </h2>
                
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full border border-border-primary rounded-xl overflow-hidden">
                    <thead className="bg-surface-secondary">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-text-primary">
                          Cookie
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-text-primary">
                          Tipo
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-text-primary">
                          Duración
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-text-primary">
                          Finalidad
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-border-primary">
                      <tr>
                        <td className="px-4 py-3 text-sm">cookieConsent</td>
                        <td className="px-4 py-3 text-sm">Técnica (propia)</td>
                        <td className="px-4 py-3 text-sm">1 año</td>
                        <td className="px-4 py-3 text-sm">
                          Almacena la preferencia de consentimiento de cookies del usuario
                        </td>
                      </tr>
                      <tr className="bg-surface-secondary/30">
                        <td className="px-4 py-3 text-sm">ph_*</td>
                        <td className="px-4 py-3 text-sm">Análisis (terceros)</td>
                        <td className="px-4 py-3 text-sm">1 año</td>
                        <td className="px-4 py-3 text-sm">
                          PostHog - Análisis de uso del sitio web de forma anónima
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* Más información */}
              <section>
                <h2 className="font-manrope text-2xl font-bold text-text-primary">
                  MÁS INFORMACIÓN
                </h2>
                <p>
                  Si tiene preguntas sobre esta Política de Cookies, puede contactar con el Titular:
                </p>
                <ul className="list-none space-y-2 pl-0 bg-surface-secondary/30 p-6 rounded-xl">
                  <li><strong>Denominación social:</strong> FRANCISCO GONZALEZ TREJO</li>
                  <li><strong>Nombre comercial:</strong> REALIMENTA NATURAL VET</li>
                  <li><strong>e-mail:</strong>{' '}
                    <a 
                      href="mailto:REALIMENTA.NATURALVET@GMAIL.COM" 
                      className="text-brand-primary hover:underline"
                    >
                      REALIMENTA.NATURALVET@GMAIL.COM
                    </a>
                  </li>
                </ul>
                <p className="mt-4">
                  Para información sobre cómo tratamos sus datos personales, consulte nuestra{' '}
                  <Link to="/privacidad" className="text-brand-primary hover:underline font-medium">
                    Política de Privacidad
                  </Link>.
                </p>
              </section>

              {/* Última actualización */}
              <p className="text-sm text-text-muted pt-8 border-t border-border-primary">
                Última actualización: Enero 2026
              </p>

            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default CookiesPage;
